import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import AdminModalForm from '../AdminModalForm';
import { MODELS } from '../../../constants/admin/settings';
import {
    fetchList,
    deleteArtists,
    fetchBulkSetEventsDependencies,
    bulkUpdateEvents
} from '../../../actions/admin/models/artists';
import { openModalFormWithData } from '../../../actions/admin/modal.forms';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import ArtistsEventFilter from '../../../components/admin/forms/artists/ArtistsEventFilter';
import { dataSelector, selectedSelector } from '../../../selectors/admin/tables';
import BulkSetEventsInputs from '../../../components/admin/lineup/BulkSetEventsInputs';

class Index extends Component {
    state = {
        modalModel: ''
    };

    _formatEvents = (_value, artist) => {
        const ids = artist.eventIds || [];
        return ids.length ? `${ids.length} event${ids.length === 1 ? '' : 's'}` : '—';
    };

    _openBulkSetEventsModal = () => {
        const selectedArtistIds = this.props.selection;
        const artistsData = this.props.artists || [];
        const selectedArtists = artistsData.filter(a => selectedArtistIds.includes(a.id));
        const commonEventIds =
            selectedArtists.length > 0 && selectedArtists.every(a => a.eventIds && a.eventIds.length >= 0)
                ? selectedArtists
                      .map(a => a.eventIds || [])
                      .reduce((acc, ids) => acc.filter(id => ids.includes(id)), selectedArtists[0].eventIds || [])
                : [];

        this.setState({ modalModel: MODELS.BULK_SET_EVENTS });
        this.props.openModalFormWithData(MODELS.BULK_SET_EVENTS, { eventIds: commonEventIds });
    };

    render() {
        const contextId = this.props.contextId;
        return (
            <React.Fragment>
                <AdminTable
                    AdvancedSearchForm={ArtistsEventFilter}
                    enableSearch={true}
                    model={MODELS.ARTIST}
                    fetchDataFunction={this.props.fetchList}
                    deleteAction={this.props.deleteArtists}
                    pagination={true}
                    selectionActions={['SET EVENTS']}
                    selectionFunctions={[this._openBulkSetEventsModal]}
                    transformFunctions={{ eventIds: this._formatEvents }}
                />
                {this.state.modalModel === MODELS.BULK_SET_EVENTS ? (
                    <AdminModalForm
                        title={`Set Events for ${this.props.selection.length} Artist${
                            this.props.selection.length === 1 ? '' : 's'
                        }`}
                        fields={BulkSetEventsInputs}
                        fetchDependencies={() => this.props.fetchBulkSetEventsDependencies(contextId)}
                        staticData={{
                            selectedItems: (this.props.artists || []).filter(a => this.props.selection.includes(a.id)),
                            itemLabel: 'artist'
                        }}
                        model={MODELS.BULK_SET_EVENTS}
                        createAction={data => this.props.bulkUpdateEvents(data, this.props.selection)}
                        confirmLabel="Save"
                    />
                ) : null}
            </React.Fragment>
        );
    }
}

const tableProps = { tableIndex: 0 };

const mapStateToProps = state => ({
    selection: selectedSelector(state, tableProps),
    artists: dataSelector(state, tableProps)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchList,
            deleteArtists,
            openModalFormWithData,
            fetchBulkSetEventsDependencies,
            bulkUpdateEvents
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(withBreadcrumb(Index, () => [BREADCRUMB.ARTISTS]));
